import React, { useContext, useEffect } from "react";
import "./OrderStatusV2.scss";
import { Grid } from "@material-ui/core";

import { withTranslation, useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import OrderDetails from "../../Components/orderStatusComponents/orderDetails/OrderDetails";
import PaymentStatus from "../../Components/orderStatusComponents/PaymentStatus";
import StatusHeader from "../../Components/orderStatusComponents/header2/StatusHeader";
import StateContext from "../../StateContext";
import ShareInvoiceQrcode from "../../Components/shareInvoiceQrcode/shareInvoiceQrcode";
import NotifyPermisssionPopup from "../../Components/notifyPermisssionPopup/notifyPermisssionPopup";
import DispatchContext from "../../DispatchContext";
import AddsSlider from "../../Components/addsBanners/addsSlider";

function OrderStatusV2({ invoiceable, invoiceDetails, orderStatus, addsInfo}) {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext)
  const { type } = useParams();
  let selfServe = invoiceable?.service_type == 'PickUp' ? true :
    invoiceable?.info?.qrcode?.section?.hotel?.self_serve ?? false;


  useEffect(() => {
    let checkSubscription = Boolean(localStorage.getItem(`service_worker_${appState?.storeInfo?.slug}`))
    if (checkSubscription == false && invoiceable.service_type == "HotelOrder" && selfServe) {
      appDispatch({
        type: "setAllowNotificationPopupMode",
        allowNotificationPopupMode: true
      })
    }
  }, [appState.pushSubscription])
  useEffect(() => {
  }, [orderStatus])
  

  return (
    <Grid
      id="invocieorderstatus"
      container
      justifyContent="center"
      className={` vh-100 ${appState.langValue === "ar" ? "directionRtl" : ""}`}
    >
      <Grid className="centerColumn" item xs={12} md={6}>
        <StatusHeader
          invoiceable={invoiceable}
          orderStatus={orderStatus}
        />
          {addsInfo != null && <span className={`${addsInfo.length > 1 ? `` : `d-flex align-items-center justify-content-center`}`}> <AddsSlider addsInfo={addsInfo} /> </span> }
        
        {/* <PaymentStatus invoiceable={invoiceable} /> */}
        <OrderDetails invoiceDetails={invoiceDetails} />
        <hr />
        <div className="col-12">
          <div className="  px-1 d-flex align-items-center justify-content-between ">
            <h5 className=" mt-2  familysora700">{t("invoice.Total-Bill")}</h5>
            <h5 className=" familysora700">{invoiceDetails.amount} {t("KWD")} </h5>
          </div>
        </div>
      </Grid>
      {appState.shareInvoiceQrcode && (
        <ShareInvoiceQrcode type={type} invoiceDetails={invoiceDetails} />
      )}

      {((appState.allowNotificationPopupMode) && (invoiceable.service_type == "HotelOrder" && selfServe)) && (<NotifyPermisssionPopup invoiceDetails={invoiceDetails} invoiceable={invoiceable} selfServe={selfServe} />)}

    </Grid>
  );
}

export default withTranslation()(OrderStatusV2);
